













import Vue from 'vue'
import { apiAddTagsToEntities } from '@/api'
import { mutations } from '@/state'

export default Vue.extend({
  name: 'AddTagsDialog',
  props: {
    addTagsModalOpened: Boolean,
    selectedEntities: Array,
    tags: Array
  },
  data () {
    return {
      modalActive: false,
      selectedTags: []
    }
  },
  methods: {
    close () {
      this.$emit('closeAddTagsModal')
      this.selectedTags = []
    },
    addTags () {
      this.$refs.tagsCombobox.blur()
      this.$nextTick(() => {
        const data = {
          entities: this.selectedEntities,
          tags: this.selectedTags
        }
        mutations.setSnackbar()
        apiAddTagsToEntities(data).then(() => {
          mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar'}))
          this.$emit('reset')
          this.close()
        }).catch(e => {
          mutations.setSnackbar('error', e.response.data.message)
        })
      })
    }
  },
  watch: {
    addTagsModalOpened (val) {
      this.modalActive = val
    }
  }
})
